import { render } from "./MahjSide.vue?vue&type=template&id=77c9b250"
import script from "./MahjSide.vue?vue&type=script&lang=js"
export * from "./MahjSide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__